<template>
  <CardPrimary
    ref="card"
    :style="style.card"
  >
    <template v-if="isLoading">
      <LoaderPrimary :style="style.loader" />
    </template>
    <template v-else-if="nodes.length > 0">
      <TeamSkillGraphPrimary
        v-bind="getTeamSkillGraphAttrs"
        :isHighlighted="isHighlighted"
        :links="edges"
        :nodes="nodes"
        :selectedNodeIds="nodeIdsOnHover"
        :triggerFitView="triggerFitView"
        :triggerNodeUpdates="triggerNodeUpdates"
      />
    </template>
    <template v-else>
      <NoDataToShow :textBottom="true">
        Add members and choose skills to show.
      </NoDataToShow>
    </template>
  </CardPrimary>
</template>

<script>
  import CardPrimary from '@modules/card/card-primary'
  import LoaderPrimary from '@modules/loader/loader-primary'
  import NoDataToShow from '@modules/error/no-data-to-show'
  import TeamSkillGraphPrimary from '@modules/graph/team-skill-graph-primary'
  import { mapState } from 'vuex'

  export default {
    name: 'SkillsGraph',
    props: {
      edges: {
        type: Array,
        required: false,
        default: () => [],
      },
      isLoading: {
        type: Boolean,
        required: false,
        default: false,
      },
      nodes: {
        type: Array,
        required: false,
        default: () => [],
      },
      parentContainerWidth: {
        type: Number,
        required: false,
        default: 0,
      },
      nodeIdsOnHover: {
        type: Array,
        required: false,
        default: () => [],
      },
      triggerFitView: {
        type: Boolean,
        required: false,
        default: false,
      },
      triggerNodeUpdates: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    components: {
      CardPrimary,
      LoaderPrimary,
      NoDataToShow,
      TeamSkillGraphPrimary,
    },
    data: function () {
      return {
        graphHeight: null,
        graphWidth: null,
        style: {
          card: {
            height: '100%',
            width: '100%',
          },
          loader: {
            height: '100%',
            width: '100%',
          },
        },
      };
    },
    mounted: async function () {
      this.setGraphHeight();
      this.setGraphWidth();
    },
    computed: {
      ...mapState({
        windowHeight: state => state.window.height,
        windowWidth: state => state.window.width,
      }),
      getTeamSkillGraphAttrs: function () {
        return {
          cursorOnHover: 'pointer',
          disableConditionPopover: true,
          height: this.graphHeight,
          width: this.graphWidth,
        };
      },
    },
    methods: {
      isHighlighted: function (node) {
        return node.required;
      },
      setGraphHeight: function () {
        this.graphHeight = this.$refs.card.$el.clientHeight;
      },
      setGraphWidth: function () {
        //this.graphWidth = this.parentContainerWidth - 32;
        this.graphWidth = this.$refs.card.$el.clientWidth;
      },
    },
    watch: {
      isLoading: function (newVal, oldVal) {
        this.setGraphHeight();
        this.setGraphWidth();
      },
      windowHeight: function (newVal, oldVal) {
        // Update both height and width
        // because web app is responsive and
        // height change may cause width change.
        this.setGraphHeight();
        this.setGraphWidth();
      },
      windowWidth: function (newVal, oldVal) {
        // Update both height and width
        // because web app is responsive and
        // width change may cause height change.
        this.setGraphHeight();
        this.setGraphWidth();
      },
    },
  };
</script>
